const LINKS = [
  { id: "journey", label: "Journey" },
  { id: "itinerary", label: "Ceremonies" },
  { id: "venue", label: "Venue" },
  { id: "rsvp", label: "RSVP" },
];

export default function Nav() {

  const toTop = (e) => {
    e?.preventDefault();
    // Home = the varmala video filling the screen (the header sits just above it)
    const video = document.getElementById("varmala");
    window.scrollTo({ top: video ? video.offsetTop : 0, behavior: "smooth" });
    // replay the opening varmala video (VarmalaVideo listens for this)
    window.dispatchEvent(new Event("varmala:replay"));
  };

  const handleJump = (e, id) => {
    e.preventDefault();
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  const linkClass = "text-rani font-semibold transition-colors hover:text-rani-deep whitespace-nowrap";

  return (
    <div id="top" className="relative z-20 edge py-3 md:py-3.5 bg-ivory">
      {/* Logo leads the links, the whole group centred. On phones the links sit under the logo. */}
      <div className="flex flex-col md:flex-row items-center justify-center gap-2 md:gap-9">
        <a href="#top" onClick={toTop} className="block" aria-label="Back to top">
          <img src="/brand/logo-wine.png" alt="Sonakshi & Shubham" className="h-11 md:h-12 w-auto" />
        </a>

        <nav className="flex gap-5 md:gap-7 overflow-x-auto max-w-full text-[10px] md:text-[11px] tracking-widest uppercase">
          <a href="#top" onClick={toTop} className={linkClass}>Home</a>
          {LINKS.map((item) => (
            <a
              key={item.id}
              href={`#${item.id}`}
              onClick={(e) => handleJump(e, item.id)}
              className={linkClass}
            >
              {item.label}
            </a>
          ))}
        </nav>
      </div>
      {/* Gold hairline that fades out at both ends */}
      <div
        className="absolute left-0 right-0 bottom-0 h-px pointer-events-none"
        style={{ background: "linear-gradient(90deg, rgba(201,169,97,0) 0%, rgba(201,169,97,0.55) 50%, rgba(201,169,97,0) 100%)" }}
      />
    </div>
  );
}
